export default __webpack_public_path__ + "static/media/adobestock.f5fc6aed.webp";